import urls from "./urls";
import axios from "axios";
export default {
    call(method, path, payload) {
        return new Promise((resolve, reject) => {
            axios({
                    method: method,
                    url: urls.baseUrl + path,
                    data: payload,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}